import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import AchievementCard from "./achievementCard";
import profileActions from "../../../../redux/profile/actions";

const Achievements = () => {
  const { achievements = [] } = useSelector((state) => ({
    achievements: state.profile.achievements,
  }));
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: profileActions.GET_ALL_ACHIEVEMENTS,
    });
  }, []);

  return (
    <div>
      {achievements
        .filter((a) => !a.hidden)
        .map((achievement, index) => (
          <AchievementCard achievement={achievement} key={index} />
        ))}
    </div>
  );
};

export default Achievements;
